import { useEffect, useState } from 'react'
import { IContactProps } from '../CustomerInformation'
import { fetchData } from '../../../../../../global/utils/fetch'
import { getIsVehicleBlacklisted } from '../api'
import styles from './styles.module.css'
import AdditionalInformationSelect from './vehicle-info-selects/AdditionalInformationSelect'
import MakeInformationSelect from './vehicle-info-selects/MakeInformationSelect'
import ModelInformationSelect from './vehicle-info-selects/ModelInformationSelect'
import YearInformationSelect from './vehicle-info-selects/YearInformationSelect'
import { IFormDataProps } from '../CustomerInformation'

export interface IVehicleInformationSelectProps {
  formData: IFormDataProps
  label: string
  onChange: Function
}

export interface IVehicleInformationFormProps extends IContactProps {
  setDisabled?: (disabled: boolean) => void
  onVehicleBlacklistChange?: (isBlacklisted: boolean) => void
}

export default function VehicleInformationForm(
  props: IVehicleInformationFormProps,
) {
  const { formData, setFormData } = props
  const [isBlacklisted, setIsBlacklisted] = useState<boolean>(false)

  useEffect(() => {
    async function checkIsBlacklistedVehicle() {
      if (formData.make && formData.model && formData.year) {
        const blacklistedResult = await fetchData<boolean>(
          getIsVehicleBlacklisted(formData.make, formData.model, formData.year),
        )
        setIsBlacklisted(blacklistedResult)
        props.onVehicleBlacklistChange &&
          props.onVehicleBlacklistChange(blacklistedResult)
      } else {
        setIsBlacklisted(false)
        props.onVehicleBlacklistChange && props.onVehicleBlacklistChange(false)
      }
    }
    checkIsBlacklistedVehicle()
  }, [formData.make, formData.model, formData.year])

  useEffect(() => {
    if (typeof props.setDisabled === 'function') {
      props.setDisabled(isBlacklisted)
    }
  }, [isBlacklisted])

  return (
    <div className={styles.contactFormContainer}>
      <div className={`${styles.contactTitle} font--bold`}>
        Vehicle Information
      </div>
      <MakeInformationSelect
        label='Make'
        formData={formData}
        onChange={setFormData}
      />
      {formData.make && (
        <YearInformationSelect
          label='Year'
          formData={formData}
          onChange={setFormData}
        />
      )}
      {formData.year && (
        <ModelInformationSelect
          label='Model'
          formData={formData}
          onChange={setFormData}
        />
      )}
      {formData.model && (
        <AdditionalInformationSelect
          label='Additional Information'
          formData={formData}
          onChange={setFormData}
        />
      )}
      {isBlacklisted && (
        <div style={{ color: 'red' }}>
          This vehicle cannot be serviced by Mobile Installation
        </div>
      )}
    </div>
  )
}
